export function safeReadCurrentUserFromSession() {
  try {
    const raw = window.sessionStorage.getItem("User");
    if (!raw) return null;
    return JSON.parse(atob(raw));
  } catch {
    return null;
  }
}

/** Permission IDs from login session (supports legacy rolePerms objects). */
export function readPermIdsFromSession(): number[] {
  const user = safeReadCurrentUserFromSession();
  if (!user) return [];

  const rawPermIds = user.permIds ?? user.PermIds;
  if (Array.isArray(rawPermIds)) {
    const ids = rawPermIds
      .map((id: unknown) => Number(id))
      .filter((id): id is number => Number.isFinite(id) && id > 0);
    return [...new Set(ids)];
  }

  if (!Array.isArray(user.rolePerms)) return [];

  const fromRolePerms: number[] = user.rolePerms
    .map((rp: { permId?: number; PermId?: number; permissionId?: number }) =>
      Number(rp?.permId ?? rp?.PermId ?? rp?.permissionId ?? 0))
    .filter((id: number): id is number => Number.isFinite(id) && id > 0);
  return [...new Set(fromRolePerms)];
}

export function readLanguageIdFromSession(): number {
  const user = safeReadCurrentUserFromSession();
  const langId = Number(user?.languageId || user?.defaultLanguageId || 1);
  return Number.isFinite(langId) && langId > 0 ? langId : 1;
}
